// Page identifiers for manual page tracking via trackPage().
// Landing and return user pages match page_details oneof keys in chime-schemas.
// Claim info and confirmation pages use item_id for public_id (no page_details).
export enum PageEvent {
  PAY_ANYONE_LANDING_PAGE = 'pay_anyone_landing_page',
  PAY_ANYONE_RETURN_USER_PAGE = 'pay_anyone_return_user_page',
  PAY_ANYONE_CLAIM_INFO_PAGE = 'pay_anyone_claim_info_page',
  PAY_ANYONE_CONFIRMATION_PAGE = 'pay_anyone_confirmation_page',
}
